import { useFeature as useLkfFeature } from "@linkfluence/core/features/use-cases";
import { Features as LkfFeatures } from "@linkfluence/models/feature";
import { Features } from "@radarly/models/features";

export function useFeature(feature: keyof Features) {
  return useLkfFeature(feature as keyof LkfFeatures);
}
